import { render, staticRenderFns } from "./ProductDetailPage.vue?vue&type=template&id=0f70e66a&scoped=true"
import script from "./ProductDetailPage.vue?vue&type=script&lang=js"
export * from "./ProductDetailPage.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailPage.vue?vue&type=style&index=0&id=0f70e66a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f70e66a",
  null
  
)

export default component.exports